import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/AuthSlice";

const persistMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const { token, user } = store.getState().auth;
  if (token) localStorage.setItem("token", token);
  else localStorage.removeItem("token");
  if (user) localStorage.setItem("user", JSON.stringify(user));
  else localStorage.removeItem("user");
  return result;
};

// Rehydrate auth state from localStorage so refresh doesn't log the user out
let preloadedUser = null;
const preloadedToken = localStorage.getItem("token") || "";
try {
  const storedUser = localStorage.getItem("user");
  if (storedUser) preloadedUser = JSON.parse(storedUser);
} catch (_) {
  preloadedUser = null;
}

export const store = configureStore({
  reducer: { auth: authReducer },
  preloadedState: {
    auth: {
      token: preloadedToken,
      user: preloadedUser,
    },
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(persistMiddleware),
});
